export const POST_TUTOR_SESSION_ONE_REQUEST = 'tutorSessionPostOneReducer/POST_TUTOR_SESSION_ONE_REQUEST';
export const POST_TUTOR_SESSION_ONE_SUCCESS = 'tutorSessionPostOneReducer/POST_TUTOR_SESSION_ONE_SUCCESS';
export const POST_TUTOR_SESSION_ONE_FAILED = 'tutorSessionPostOneReducer/POST_TUTOR_SESSION_ONE_FAILED';